'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.QueryNodeWalker = exports.QueryNodeVisitor = exports.Cardinality = exports.Operators = exports.prepareAllFilesQuery = exports.prepareUnfiledDocumentsQuery = exports.getBinderIndexingMetadata = exports.prepareQuery = exports.evaluateQueryFragment = exports.ValueSetRegistry = exports.QueryNodeRegistry = exports.validateBinderConfiguration = exports.validateQuery = exports.jsonHelper = exports.ValueSets = exports.Nodes = exports.DapsNodes = exports.Predicates = exports.Conditions = exports.Abstract = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _QueryNode = require('./QueryNode');

var _QueryNode2 = _interopRequireDefault(_QueryNode);

var _ValueSet = require('./ValueSet');

var _ValueSet2 = _interopRequireDefault(_ValueSet);

var _Condition = require('./abstract/Condition');

var _Condition2 = _interopRequireDefault(_Condition);

var _Predicate = require('./abstract/Predicate');

var _Predicate2 = _interopRequireDefault(_Predicate);

var _AndCondition = require('./conditions/AndCondition');

var _AndCondition2 = _interopRequireDefault(_AndCondition);

var _OrCondition = require('./conditions/OrCondition');

var _OrCondition2 = _interopRequireDefault(_OrCondition);

var _NotCondition = require('./conditions/NotCondition');

var _NotCondition2 = _interopRequireDefault(_NotCondition);

var _Conditions2 = require('./conditions/Conditions');

var _Conditions3 = _interopRequireDefault(_Conditions2);

var _DapsAndCondition = require('./conditions/DapsAndCondition');

var _DapsAndCondition2 = _interopRequireDefault(_DapsAndCondition);

var _DapsOrCondition = require('./conditions/DapsOrCondition');

var _DapsOrCondition2 = _interopRequireDefault(_DapsOrCondition);

var _DapsNotCondition = require('./conditions/DapsNotCondition');

var _DapsNotCondition2 = _interopRequireDefault(_DapsNotCondition);

var _DapsConditions = require('./conditions/DapsConditions');

var _DapsConditions2 = _interopRequireDefault(_DapsConditions);

var _DocumentType = require('./predicates/DocumentType');

var _DocumentType2 = _interopRequireDefault(_DocumentType);

var _DocumentTypeList = require('./predicates/DocumentTypeList');

var _DocumentTypeList2 = _interopRequireDefault(_DocumentTypeList);

var _Descriptor = require('./predicates/Descriptor');

var _Descriptor2 = _interopRequireDefault(_Descriptor);

var _DapsDescriptor = require('./predicates/DapsDescriptor');

var _DapsDescriptor2 = _interopRequireDefault(_DapsDescriptor);

var _CommitDate = require('./predicates/CommitDate');

var _CommitDate2 = _interopRequireDefault(_CommitDate);

var _UploadDate = require('./predicates/UploadDate');

var _UploadDate2 = _interopRequireDefault(_UploadDate);

var _UploadUser = require('./predicates/UploadUser');

var _UploadUser2 = _interopRequireDefault(_UploadUser);

var _DocumentStatus = require('./predicates/DocumentStatus');

var _DocumentStatus2 = _interopRequireDefault(_DocumentStatus);

var _FixedValue = require('./valuesets/FixedValue');

var _FixedValue2 = _interopRequireDefault(_FixedValue);

var _ScalarValue = require('./valuesets/ScalarValue');

var _ScalarValue2 = _interopRequireDefault(_ScalarValue);

var _SelectList = require('./valuesets/SelectList');

var _SelectList2 = _interopRequireDefault(_SelectList);

var _MultiselectList = require('./valuesets/MultiselectList');

var _MultiselectList2 = _interopRequireDefault(_MultiselectList);

var _ValueList = require('./valuesets/ValueList');

var _ValueList2 = _interopRequireDefault(_ValueList);

var _DatasetFixedValue = require('./valuesets/DatasetFixedValue');

var _DatasetFixedValue2 = _interopRequireDefault(_DatasetFixedValue);

var _DatasetSingleValue = require('./valuesets/DatasetSingleValue');

var _DatasetSingleValue2 = _interopRequireDefault(_DatasetSingleValue);

var _DatasetValueList = require('./valuesets/DatasetValueList');

var _DatasetValueList2 = _interopRequireDefault(_DatasetValueList);

var _DatasetMultiselectList = require('./valuesets/DatasetMultiselectList');

var _DatasetMultiselectList2 = _interopRequireDefault(_DatasetMultiselectList);

var _DataSourceSingleValue = require('./valuesets/DataSourceSingleValue');

var _DataSourceSingleValue2 = _interopRequireDefault(_DataSourceSingleValue);

var _DataSourceMultipleValue = require('./valuesets/DataSourceMultipleValue');

var _DataSourceMultipleValue2 = _interopRequireDefault(_DataSourceMultipleValue);

var _DataSourceValueList = require('./valuesets/DataSourceValueList');

var _DataSourceValueList2 = _interopRequireDefault(_DataSourceValueList);

var _jsonHelper2 = require('./jsonHelper');

var _jsonHelper3 = _interopRequireDefault(_jsonHelper2);

var _QueryNodeRegistry2 = require('./QueryNodeRegistry');

var _QueryNodeRegistry3 = _interopRequireDefault(_QueryNodeRegistry2);

var _ValueSetRegistry2 = require('./ValueSetRegistry');

var _ValueSetRegistry3 = _interopRequireDefault(_ValueSetRegistry2);

var _evaluateQueryFragment2 = require('./evaluateQueryFragment');

var _operators = require('./operators');

var _Operators = _interopRequireWildcard(_operators);

var _cardinality = require('./cardinality');

var _Cardinality = _interopRequireWildcard(_cardinality);

var _prepareQuery2 = require('./prepareQuery');

var _binderIndexingMetadata = require('./binderIndexingMetadata');

var _QueryNodeVisitor2 = require('./engine/QueryNodeVisitor');

var _QueryNodeVisitor3 = _interopRequireDefault(_QueryNodeVisitor2);

var _QueryNodeWalker2 = require('./engine/QueryNodeWalker');

var _QueryNodeWalker3 = _interopRequireDefault(_QueryNodeWalker2);

var _validateQuery2 = require('./validateQuery');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//use this file to ensure every type is loaded into the QueryNodeRegistry

var Abstract = exports.Abstract = {
    QueryNode: _QueryNode2.default,
    ValueSet: _ValueSet2.default,
    Condition: _Condition2.default,
    Predicate: _Predicate2.default
};

var Conditions = exports.Conditions = {
    Conditions: _Conditions3.default,
    AndCondition: _AndCondition2.default,
    OrCondition: _OrCondition2.default,
    NotCondition: _NotCondition2.default
};

var Predicates = exports.Predicates = {
    DocumentType: _DocumentType2.default,
    DocumentTypeList: _DocumentTypeList2.default,
    Descriptor: _Descriptor2.default,
    CommitDate: _CommitDate2.default,
    UploadDate: _UploadDate2.default,
    UploadUser: _UploadUser2.default,
    DocumentStatus: _DocumentStatus2.default
};

var DapsNodes = exports.DapsNodes = {
    DapsConditions: _DapsConditions2.default,
    DapsAndCondition: _DapsAndCondition2.default,
    DapsOrCondition: _DapsOrCondition2.default,
    DapsNotCondition: _DapsNotCondition2.default,
    DapsDescriptor: _DapsDescriptor2.default
};

var Nodes = exports.Nodes = (0, _extends3.default)({}, Conditions, Predicates, DapsNodes);

var ValueSets = exports.ValueSets = {
    FixedValue: _FixedValue2.default,
    ScalarValue: _ScalarValue2.default,
    SelectList: _SelectList2.default,
    MultiselectList: _MultiselectList2.default,
    ValueList: _ValueList2.default,
    DatasetFixedValue: _DatasetFixedValue2.default,
    DatasetSingleValue: _DatasetSingleValue2.default,
    DatasetValueList: _DatasetValueList2.default,
    DatasetMultiselectList: _DatasetMultiselectList2.default,
    DataSourceSingleValue: _DataSourceSingleValue2.default,
    DataSourceMultipleValue: _DataSourceMultipleValue2.default,
    DataSourceValueList: _DataSourceValueList2.default
};

var jsonHelper = exports.jsonHelper = _jsonHelper3.default;
var validateQuery = exports.validateQuery = _validateQuery2.validateQuery;
var validateBinderConfiguration = exports.validateBinderConfiguration = _validateQuery2.validateBinderConfiguration;
var QueryNodeRegistry = exports.QueryNodeRegistry = _QueryNodeRegistry3.default;
var ValueSetRegistry = exports.ValueSetRegistry = _ValueSetRegistry3.default;
var evaluateQueryFragment = exports.evaluateQueryFragment = _evaluateQueryFragment2.evaluateQueryFragment;
var prepareQuery = exports.prepareQuery = _prepareQuery2.prepareQuery;
var getBinderIndexingMetadata = exports.getBinderIndexingMetadata = _binderIndexingMetadata.getBinderIndexingMetadata;
var prepareUnfiledDocumentsQuery = exports.prepareUnfiledDocumentsQuery = _prepareQuery2.prepareUnfiledDocumentsQuery;
var prepareAllFilesQuery = exports.prepareAllFilesQuery = _prepareQuery2.prepareAllFilesQuery;
var Operators = exports.Operators = _Operators;
var Cardinality = exports.Cardinality = _Cardinality;
var QueryNodeVisitor = exports.QueryNodeVisitor = _QueryNodeVisitor3.default;
var QueryNodeWalker = exports.QueryNodeWalker = _QueryNodeWalker3.default;

exports.default = {
    Abstract: Abstract,
    Conditions: Conditions,
    Predicates: Predicates,
    Nodes: Nodes,
    ValueSets: ValueSets,
    jsonHelper: jsonHelper,
    validateQuery: validateQuery,
    validateBinderConfiguration: validateBinderConfiguration,
    QueryNodeRegistry: QueryNodeRegistry,
    ValueSetRegistry: ValueSetRegistry,
    evaluateQueryFragment: evaluateQueryFragment,
    prepareQuery: prepareQuery,
    getBinderIndexingMetadata: getBinderIndexingMetadata,
    prepareUnfiledDocumentsQuery: prepareUnfiledDocumentsQuery,
    prepareAllFilesQuery: prepareAllFilesQuery,
    Operators: Operators,
    Cardinality: Cardinality,
    QueryNodeVisitor: QueryNodeVisitor,
    QueryNodeWalker: QueryNodeWalker
};